const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.WALLETS)
const walletLimitsRoute = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.WALLET_LIMITS)

export const apiClientWallets = {
	fetchWalletLimits: async (): Promise<IWalletLimitsModel> => {
		const { data } = await apiCommon<IWalletLimits>(walletLimitsRoute, { method: 'GET' })
		return WalletLimits(data)
	},

	updateWalletLimits: async (form: IWalletLimitsForm): Promise<IWalletLimitsModel> => {
		const { data } = await apiCommon<IWalletLimits>(walletLimitsRoute, {
			method: 'PATCH',
			body: WalletLimitsToPayload(form),
		})
		return WalletLimits(data)
	},

	walletStats: async (clientId: number, walletType: EWalletType): Promise<IWalletStatsModel> => {
		const { data } = await apiCommon<IWalletStats>(`${groupPrefix}/${clientId}/stats`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { wallet_type: walletType }),
		})
		return walletStatsToJSON(data)
	},

	walletOverview: async (clientId: number): Promise<IWalletOverviewModel> => {
		const { data } = await apiCommon<IWalletOverview>(`${groupPrefix}/${clientId}`, { method: 'GET' })
		return walletOverviewToJSON(data)
	},

	walletHistory: async (
		clientId: number,
		walletType: EWalletType,
		page: number = 1,
		perPage: number = 25,
	): Promise<{ data: IClientWalletHistoryModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IClientWalletHistory[]>(`${groupPrefix}/${clientId}/history`, {
			method: 'GET',
			...createQuery({ page, perPage }, { wallet_type: walletType }),
		})
		return { data: data.map(clientWalletHistoryToJSON), meta }
	},

	walletsBalanceChange: async (clientID: number, payload: IClientFundsForm): Promise<IClientWalletHistoryModel> => {
		const { data } = await apiCommon<IClientWalletHistory>(`${groupPrefix}/${clientID}/adjustments`, {
			method: 'POST',
			body: payload,
		})
		return clientWalletHistoryToJSON(data)
	},

	walletsBulkBalanceChange: async (payload: IBulkFundsPayload): Promise<IBulkFundsModel> => {
		const { data } = await apiCommon<IBulkFundsResponse>(`${groupPrefix}/bulk-adjust`, {
			method: 'POST',
			body: payload,
		})
		return bulkFundsFromJSON(data)
	},

	walletsBulkAdjustImport: async (payload: IBulkFundsImportPayload): Promise<IBulkFundsImportModel> => {
		const formData = new FormData()
		formData.append('file', payload.file)
		formData.append('action', payload.action)
		formData.append('wallet_type', payload.wallet_type)
		if (payload.comment) {
			formData.append('comment', payload.comment)
		}

		const { data } = await apiCommon<IBulkFundsImportResponse>(
			`${groupPrefix}/bulk-adjust/import`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)
		return bulkFundsImportFromJSON(data)
	},

	walletsBulkAdjustBatchStatus: async (batchId: string): Promise<IBulkFundsBatchStatusModel> => {
		const { data } = await apiCommon<IBulkFundsBatchStatus>(`${groupPrefix}/bulk-adjust/${batchId}`, {
			method: 'GET',
		})
		return bulkFundsBatchStatusFromJSON(data)
	},
}
